import { render } from "./TextCheck.vue?vue&type=template&id=31471b48&scoped=true"
import script from "./TextCheck.vue?vue&type=script&lang=js"
export * from "./TextCheck.vue?vue&type=script&lang=js"

import "./TextCheck.vue?vue&type=style&index=0&id=31471b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31471b48"]])

export default __exports__